export enum DataHooks {
  ROOT = 'service-image-root',
  WRAPPER = 'service-image-wrapper',
  CONTAINER = 'service-image-container',
  IMAGE = 'service-image',
}
